
import React from "react";

interface CourseHeaderProps {
  title: string;
}

const CourseHeader = ({ title }: CourseHeaderProps) => (
  <h1 className="text-3xl font-bold text-kaija-accent mb-3">{title}</h1>
);

export default CourseHeader;
